<template>
  <div class="mobile-auth-confirm-page">
    <mobile-header theme="light" :show-menu="false" />

    <template v-if="!loading">
      <div
        class="d-flex flex-column"
        style="align-items: center; height: 90vh"
        v-if="true"
      >
        <div>
          <img
            class="logo"
            src="/static/images/nav_logo_primary.png"
            style="width: 200px"
          />
        </div>
        <div>
          <div
            class="d-flex flex-column"
            style="gap: 20px; align-items: center"
          >
            <img src="/static/images/lined_check.svg" style="height: 110px" />
            <div>
              <center style="font-weight: 800; font-size: 24px">
                Email confirmed!
              </center>
              <center style="font-weight: 500; font-size: 20px">Your account has been activated</center>
            </div>
          </div>
        </div>
        <div style="margin-bottom: -130px">
          <button
            style="
              background-color: black;
              width: 300px;
              padding: 15px 5px;
              border-radius: 25px;
              color: white;
              font-size: 18px;
            "
          >
            <a href="ys://login" style="all: unset">Open App</a>
          </button>
        </div>
      </div>

      <div class="section" v-else>
        <h3>Check your email</h3>
        <!-- <a @click.stop="sendConfirmEmail()"> Resend Confirmation E-mail </a> -->
      </div>
    </template>
  </div>
</template>

<script>
import AuthService from '@/services/auth';
import MobileHeader from '@/views/mobile/components/header';

export default {
  components: {
    MobileHeader,
  },

  data() {
    return {
      loading: true,
      token: null,
      confirmed: false,
    };
  },

  created() {
    this.token = this.$route.params.token

    const params = {
      confirmation_token: this.token,
    };

    AuthService.activeAccount(params)
      .then((response) => {
        console.log('done');
        this.confirmed = true;
        this.loading = false;
      })
      .catch((e) => {
        console.log('error', e.status, e);
        if (
          e.body.errors[0].detail ===
          'was already confirmed, please try signing in'
        ) {
          this.confirmed = true;
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
  },
  mounted() {
    $('.sidebar').css('display', 'none');
    $('.mobile-header').css('display', 'none');
    setTimeout(() => {
      $('main').css('padding', 'unset');
    }, 0);
  },

  methods: {
    sendConfirmEmail() {
      const params = {
        email: this.email,
      }
      AuthService.sendConfirmEmail(params)
        .then((response) => {
          this.$store.dispatch('error/showSuccessToast', [
            'Resent a confirmation email',
          ])
        })
        .catch((e) => {
          this.$store.dispatch(
            'error/showErrorToast',
            e.body.errors || [e.body]
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-auth-confirm-page {
  .section {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__content {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        height: 60px;
      }
    }

    &__footer {
      height: 120px;
      flex: 0 0 auto;
      text-align: center;

      p {
        margin-bottom: 0;
        font-size: 14px;
      }

      a {
        color: #000;
        line-height: 40px;
        font-size: 16px;
        font-weight: 700;
      }
    }

    h3 {
      font-size: 24px;
    }
  }

  .header-container {
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// confirmation.vue?63e8a038